<template>  
     <div class="custom-control custom-checkbox">  

        <input  
            type="checkbox" 
            class="custom-control-input e2e-checkbox"
            :class="fragment.semanticInvalid?'is-invalid':''"
            :id="fragment.uuid"
            :disabled="!fragment.editable"
            v-model="checked"> 

        <label :for="fragment.uuid" class="custom-control-label">
            <i v-if="fragment.semanticInvalid === true" class="fa fa-times" style="color: red" aria-hidden="true"></i>
            <i v-if="fragment.semanticInvalid === false" class="fa fa-check" style="color: lime" aria-hidden="true"></i>
            <div  :fragment="fragment.label"
                  :is="resolveFragmentComponentName(fragment.label)">
            </div>
        </label>

        <!-- allways send checked state -->
        <input  type="hidden" 
                v-if="checked"
                :name="fragment.groupUuid" 
                :value="fragment.uuid"> 

        <!-- allways keep track of group -->
        <input  type="hidden"  
                :name="fragment.groupUuid" 
                :value="fragment.groupUuid"> 

        <div class="invalid-feedback" v-if="fragment.semanticInvalid" >
          {{fragment.semanticInvalidMessage}}
        </div>
    </div> 
</template>

<script>
import { resolveFragmentComponentName } from "./output-fragment-resolver.js";

export default {
  name: "fragment-checkbox",
  props: ["fragment"],
  data:function(){
    return {
      checked: false
    };
  },
  methods: {
    resolveFragmentComponentName
  },
  mounted(){
    this.checked = this.fragment.checked;
  }
};
</script>
 

<style scoped>
</style>